"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateRBACAppConfig = function (user) {
    var config = {};
    var features = user.features, gates = user.gates;
    var canWriteContacts = utils_1.hasFeature(features, { featureName: "contacts", accessLevel: "WRITE" });
    var canWriteToConvos = utils_1.hasFeature(features, { featureName: "convo_view_all", accessLevel: "WRITE" })
        || utils_1.hasFeature(features, { featureName: "convo_view_no_participants", accessLevel: "WRITE" })
        || utils_1.hasFeature(features, { featureName: "convo_view_only_mine", accessLevel: "WRITE" });
    var canWriteToNoParticipants = utils_1.hasFeature(features, { featureName: "convo_view_all", accessLevel: "WRITE" })
        || utils_1.hasFeature(features, { featureName: "convo_view_no_participants", accessLevel: "WRITE" });
    var canSeeAllConvos = utils_1.hasFeature(features, { featureName: "convo_view_all", accessLevel: "READ" });
    var hasWriteWidgetSettings = utils_1.hasFeature(features, { featureName: "widget_settings", accessLevel: "WRITE" });
    var hasAdminEmailNotificationSettings = utils_1.hasFeature(features, { featureName: "admin_email_notifications", accessLevel: "READ" });
    var hasAccountActivityNotifications = utils_1.hasFeature(features, { featureName: "prospector", accessLevel: "READ" });
    var hasWriteConversationSettings = utils_1.hasFeature(features, { featureName: "conversation_settings", accessLevel: "WRITE" });
    config = ramda_1.set(ramda_1.lensProp('isVideoUserOnly'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasAllConversations'), canSeeAllConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasMyConversations'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasNoParticipants'), canWriteToNoParticipants, config);
    config = ramda_1.set(ramda_1.lensProp('mySlicesHeaderCopy'), 'My Open Conversations', config);
    config = ramda_1.set(ramda_1.lensProp('hasFilteredConversationsList'), canSeeAllConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasAbm'), !!gates.ABM, config);
    config = ramda_1.set(ramda_1.lensProp('hideMyConversationsSliceWhenEmpty'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasLiveSlice'), !!gates.has_inbox_visitor_presence && canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasClosedOnlySlice'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasComposer'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInComposer'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversationStatusDropdown'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasCloseAndLeaveStatusOption'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('statusOptions'), ['OPEN', 'PENDING', 'CLOSED'], config);
    config = ramda_1.set(ramda_1.lensProp('hasSearch'), canSeeAllConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasAgentStatusTray'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasWidgetInstallBanner'), hasWriteWidgetSettings, config);
    config = ramda_1.set(ramda_1.lensProp('hasHyperlinkedContactName'), canWriteContacts, config);
    config = ramda_1.set(ramda_1.lensProp('hasLeadActions'), canWriteContacts, config);
    config = ramda_1.set(ramda_1.lensProp('hasFullActivityTimelineButton'), canWriteContacts, config);
    // RBAC users have analysis in the subnav
    config = ramda_1.set(ramda_1.lensProp('showSubnav'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasAdminNotificationSettings'), hasAdminEmailNotificationSettings, config);
    config = ramda_1.set(ramda_1.lensProp('hasAccountActivityNotifications'), hasAccountActivityNotifications, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoNotifications'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), hasAdminEmailNotificationSettings || hasAccountActivityNotifications || canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasAbilityToTag'), canWriteToConvos, config);
    config = ramda_1.set(ramda_1.lensProp('hasEditableTags'), hasWriteConversationSettings, config);
    return config;
};
exports["default"] = generateRBACAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/conversationsWeb/rbac.js
// module id = 82GA
// module chunks = 88